<nav class="jumpnav position-absolute" role="navigation" aria-label="Sprunglinks">
  <a href="#" (click)="goTo('main', $event)" tabindex="0">zu den Hauptinhalten springen</a>
</nav>
<now-wbsuche-lib-header class="d-print-none"></now-wbsuche-lib-header>
<main id="main">
  <ng-content></ng-content>
</main>
<now-wbsuche-lib-footer class="d-print-none"></now-wbsuche-lib-footer>
